// @ts-strict-ignore
import { UI_STRINGS as u } from './uistrings-tolgee';

export const UI_STRINGS = u;
export const UI_STRINGS_MODEL = UI_STRINGS.MODEL;
